// Session Storage stores...
//    current user
//        key: cuid
//        value: current user id
// Local Storage stores...
//    user list
//        key:    users
//        value:  array of user objects
//                { id: user id
//                  name: nickname
//                  color: color hex value
//                  badge: latest, average, both
//                }
//    score data
//        key:    user id + drill id
//        value:  { latest: latest score, trials: number of trials, average: average score }
//

export var userRecord = {
  // intended to be private
  defaultUser: { id: 1, name: 'Guest', color: '#B0BEC5', badge: 'all' },
  currentUser: null,
  allUsers: null,
  _load: function () {
    this.allUsers = JSON.parse(localStorage.getItem('users'))
    if (!this.allUsers) this.allUsers = [ this.defaultUser ]

    var cuid = parseInt(sessionStorage.getItem('cuid')) || 1
    for (var i = 0; i < this.allUsers.length; i++) {
      if (this.allUsers[i].id !== cuid) continue
      this.currentUser = this.allUsers[i]; break
    }
    if (!this.currentUser) this.currentUser = this.defaultUser
  },
  _clear: function () {
    this.currentUser = null
    this.allUsers = null
  },
  // intended to be public
  all: function () {
    if (!this.allUsers) this._load()
    return this.allUsers
  },
  current: function () {
    if (!this.currentUser) this._load()
    return this.currentUser
  },
  nextslot: function () {
    if (!this.allUsers) this._load()

    for (var i = 0, uid = 1; i < this.allUsers.length; i++) {
      if (this.allUsers[i].id > uid) uid = this.allUsers[i].id
    }
    // return defalut settings with next available id
    return { id: uid + 1, name: null, color: '#B0BEC5', badge: 'all' }
  },
  add: function (user) {
    if (!this.allUsers) this._load()

    this.allUsers.push(user)
    localStorage.setItem('users', JSON.stringify(this.allUsers))
  },
  update: function (user) {
    if (!this.allUsers) this._load()

    for (var i = 0; i < this.allUsers.length; i++) {
      if (this.allUsers[i].id === user.id) {
        this.allUsers[i] = user
        break
      }
    }
    localStorage.setItem('users', JSON.stringify(this.allUsers))

    if (user.id === this.currentUser.id) this.currentUser = user
  },
  delete: function (user) {
    if (!this.allUsers) this._load()

    for (var i = 0; i < this.allUsers.length; i++) {
      if (this.allUsers[i].id === user.id) {
        this.allUsers.splice(i, 1)
        break
      }
    }
    localStorage.setItem('users', JSON.stringify(this.allUsers))

    if (user.id === this.currentUser.id) this.currentUser = this.default
  },
  isDefault: function (user) {
    return this.defaultUser.id === user.id
  },
  isCurrent: function (user) {
    if (!this.currentUser) this._load()
    return this.currentUser.id === user.id
  },
  updateCurrent: function (user) {
    this.currentUser = user
    sessionStorage.setItem('cuid', user.id)
  }
}

export var scoreRecord = {
  // intended to be private
  uid: null,
  drill: null,
  record: null,
  _key: function (uid, drill) {
    return uid + '_' + drill
  },
  _load: function (uid, drill) {
    this.uid = uid
    this.drill = drill

    var key = this._key(uid, drill)
    this.record = JSON.parse(localStorage.getItem(key))
  },
  _clear: function () {
    this.uid = null
    this.drill = null
    this.record = null
  },
  // intended to be public
  latest: function (uid, drill) {
    if (this.uid !== uid || this.drill !== drill) this._load(uid, drill)

    return this.record ? this.record.latest : 0
  },
  trials: function (uid, drill) {
    if (this.uid !== uid || this.drill !== drill) this._load(uid, drill)

    return this.record ? this.record.trials : 0
  },
  average: function (uid, drill) {
    if (this.uid !== uid || this.drill !== drill) this._load(uid, drill)

    return this.record ? this.record.average : 0
  },
  // intended to be used just in this module
  update: function (uid, drill, score) {
    if (this.uid !== uid || this.drill !== drill) this._load(uid, drill)

    if (this.record) {
      var oldsum = this.record.trials * this.record.average
      var newavg = (oldsum + score) / (this.record.trials + 1)

      this.record.trials += 1
      this.record.latest = score
      this.record.average = Math.ceil(newavg)
    } else {
      this.record = { latest: score, trials: 1, average: score }
    }

    var key = this._key(uid, drill)
    localStorage.setItem(key, JSON.stringify(this.record))
  },
  delete: function (uid) {
    var startwith = uid + '_'
    var len = startwith.length

    Object.keys(localStorage).forEach(function (key) {
      if (key.substring(0, len) === startwith) {
        localStorage.removeItem(key)
      }
    })

    if (this.uid === uid) this._clear()
  }
}

export var allRecords = {
  delete: function () {
    localStorage.clear()
    userRecord._clear()
    scoreRecord._clear()
  }
}



// WEBPACK FOOTER //
// ./src/common/js/store.js